import { useEffect, useState } from "react";
import "./Alert.css";
const Alert = ({ payload }) => {
  const [textLocal, setTextLocal] = useState("");
  const [modeLocal, setModeLocal] = useState("");

  useEffect(() => {
    console.log("new payload",payload)
    setTextLocal(() => payload.text);
    setModeLocal(() => payload.mode);
    if (!payload.text || payload.mode === "warning" || payload.mode === "danger") return undefined;
    const timer = setTimeout(() => {
      setTextLocal("");
      setModeLocal("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [payload]);

  if (!textLocal) {
    return null;
  }
  const closeAlert = () => {
    setTextLocal("");
    setModeLocal("");
  };
  return (
    <div
      className={`customAlert customAlert--${modeLocal} rounded shadow-lg d-flex justify-content-center align-items-center`}
      role="alert"
      onClick={closeAlert}
    >
      <button
        type="button"
        className="customAlert__close"
        onClick={closeAlert}
        aria-label="סגירת הודעה"
      >
        ×
      </button>
      <span className="customAlert__text text-center">{textLocal}</span>
    </div>
  );
};

export default Alert;
